import React, {ChangeEvent, FormEvent, useCallback, useEffect, useState} from "react";
import { useHistory } from "react-router-dom";

import SiteWrapper from "../../base/SiteWrapper";
import { useAuth } from "../../hooks/AuthContext";

import {Page, Card, Table, Text, Button, Form} from "tabler-react";
import Log from "../../interfaces/Log";
import { AuditLogOperationMap } from "../../enum/LogOperationEnum";
import { formatDateToDDMMYYYY } from "../../utils/formatDate";
import api from "../../services/api";
import ReactPaginate from "react-paginate";

function LogList() {
    const history = useHistory();
    const { user } = useAuth();
    const apiSender = api()
    const [page, setPage]= useState(1);
    const [pageCount, setPageCount]= useState(0);
    const [logList, setLogList] = useState<Log[]>([]);
    const [username, setUsername] = useState<string>();
    const [route, setRoute] = useState<string>();

    const handlePaginate = useCallback((selectedItem: { selected: number }) => {
        setPage(selectedItem.selected + 1);
    }, []);

    const fetchLogs = async () => {
        try {
            const tokenMonitor=  localStorage.getItem('@fidegg:tokenMonitor');
            apiSender.defaults.headers.authorization = `Bearer ${tokenMonitor}`
            const params = {
                page,
                username,
                route,
            };
            const response = await apiSender.get("log", {params});
            if (response.status === 200) {
                setLogList(response.data.data);
                setPageCount(response.data.total || 1);
            }
        } catch (error) {
            console.error("Erro ao buscar logs:", error);
        }
    };

    useEffect(() => {
        if (!user?.master) {
            history.push("/");
            return;
        }

        fetchLogs();
    }, [user, history, page]);

    function handleViewClick(log: Log) {
        history.push(`/log/form/${log.id}`);
    }

    async function handleSubmitSearch(event: FormEvent) {
        event.preventDefault();
        await fetchLogs();
    }

    function handleUserChange(event: ChangeEvent<HTMLInputElement>) {
        setUsername(event.target.value);
    }

    function handleRouteChange(event: ChangeEvent<HTMLInputElement>) {
        setRoute(event.target.value);
    }

    return (
        <SiteWrapper>
            <Page.Content>
                <Card>
                    <Card.Header>
                        <Card.Title>Logs do Banco</Card.Title>
                        <Card.Options>
                        <Form onSubmit={handleSubmitSearch}>
                            <Form.InputGroup>
                                <Form.Input
                                    className="form-control-sm"
                                    placeholder="Usuário"
                                    name="user"
                                    onChange={handleUserChange}
                                />
                                <Form.Input
                                    className="form-control-sm"
                                    placeholder="Rota"
                                    name="route"
                                    onChange={handleRouteChange}
                                />
                                <span className="input-group-btn ml-2">
                                <Button
                                    size="sm"
                                    color="default"
                                    type="submit"
                                    icon="search"
                                />
                              </span>
                            </Form.InputGroup>
                        </Form>
                        </Card.Options>
                    </Card.Header>
                    <Table
                        responsive
                        className="card-table table-vcenter text-nowrap"
                        headerItems={[
                            { content: "ID", alignContent: "center" },
                            { content: "Data", alignContent: "center" },
                            { content: "Tabela", alignContent: "center" },
                            { content: "Rota", alignContent: "center" },
                            { content: "Operação", alignContent: "center" },
                            { content: "Usuário", alignContent: "center" },
                            { content: "Visualizar", alignContent: "center" },
                        ]}
                        bodyItems={logList.map((log) => ({
                            key: log.id,
                            item: [
                                {
                                    alignContent: "center",
                                    content: <Text>{log.id}</Text>,
                                },
                                {
                                    alignContent: "center",
                                    content: <Text>{formatDateToDDMMYYYY(log.date)}</Text>,
                                },
                                {
                                    alignContent: "center",
                                    content: <Text>{log.table}</Text>,
                                },
                                {
                                    alignContent: "center",
                                    content: <Text>{log.route}</Text>,
                                },
                                {
                                    alignContent: "center",
                                    content: <Text>{AuditLogOperationMap.get(log.operation)}</Text>,
                                },
                                {
                                    alignContent: "center",
                                    content: <Text>{log.user || log.session_user_name}</Text>,
                                },
                                {
                                    alignContent: "center",
                                    content: (
                                        <Button
                                            color="secondary"
                                            size="sm"
                                            className="m-1"
                                            icon="eye"
                                            onClick={() => handleViewClick(log)}
                                        />
                                    ),
                                },
                            ],
                        }))}
                    />
                </Card>
                <Card.Footer>
                    <ReactPaginate
                        previousLabel={'<'}
                        nextLabel={'>'}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={2}
                        onPageChange={handlePaginate}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                    />
                </Card.Footer>
            </Page.Content>
        </SiteWrapper>
    );
}

export default LogList;
